// extracted by mini-css-extract-plugin
module.exports = {"jobs":"style_jobs__x2gfW","job-info":"style_job-info__CqBTd"};